import React from 'react';
import { useSelector } from 'react-redux';
import { Switch, Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

import {
  HOME_ROUTE,
  SELECT_PRODUCT_MOBILE,
  MOTIVE_MESSAGE_MOBILE,
  TICKET_SUCCESSFUL,
  TICKET_SUCCESSFUL_INNER_FORMS,
  TICKET_ERROR,
  NOT_RECEIVED_PRODUCT,
  NOT_RECEIVED_PRODUCT_MOBILE,
  AUTHORIZE_THIRD,
  AUTHORIZE_THIRD_MOBILE,
  CHANGE_ADDRESS,
  CHANGE_ADDRESS_MOBILE,
  CHANGE_DATE,
  CHANGE_DATE_MOBILE,
  GOLD_DISPATCH_CHARGE,
  GOLD_DISPATCH_CHARGE_MOBILE,
  BAD_STATE_PRODUCT,
  INCOMPLETE_PRODUCT,
  OTHER_PRODUCT,
  NOT_WORKING_PRODUCT,
  PRODUCT_WITH_ALARM,
  CANCEL_PURCHASE,
  STATUS_CANCEL_PURCHASE,
  REVERSE_OUT_OF_TIME,
  ASSEMBLE_PRODUCT,
  CHANGE_EMAIL,
  CHANGE_EMAIL_MOBILE,
  CHANGE_PASS_RIPLEY_COM,
  CHANGE_PASS_RIPLEY_COM_MOBILE,
  INVOICE_COPY,
  PROBLEM_IN_PURCHASE,
  PAGE_ERROR,
  REMOVE_CLIENT_DATA,
  GET_GIFTCARD_BALANCE,
  EXTEND_VALIDITY,
  PROBLEMS_GIFTCARD,
  PROBLEMS_GIFTCARD_MOBILE,
  ARCO_LAW_INFO,
  RPHONE,
  DEBIT,
  PROVIDERS,
  STORE,
} from '../../constants/routes';

import Contact from './Contact';
import SelectProductMobile from './SelectProductMobile';
import AlertMessageMobile from './AlertMessageMobile';

import TicketConfirmation from '../common/TicketConfirmation';
import TicketConfirmationInnerForms from '../common/TicketConfirmationInnerForms';
import TickerError from '../common/TicketError';

import NotReceived from './Issues/DispatchAndPickUp/NotReceived';
import NotReceivedMobile from './Issues/DispatchAndPickUp/NotReceived/NotReceivedMobile';
import AuthorizeThird from './Issues/DispatchAndPickUp/AuthorizeThird';
import AuthorizeThirdMobile from './Issues/DispatchAndPickUp/AuthorizeThird/AuthorizeThirdMobile';
import ChangeAddress from './Issues/DispatchAndPickUp/ChangeAddress';
import ChangeAddressMobile from './Issues/DispatchAndPickUp/ChangeAddress/ChangeAddressMobile';
import ChangeDate from './Issues/DispatchAndPickUp/ChangeDate';
import ChangeDateMobile from './Issues/DispatchAndPickUp/ChangeDate/ChangeDateMobile';
import GoldSilverDispatchCharge from './Issues/DispatchAndPickUp/GoldSilverDispatchCharge';
import GoldSilverDispatchChargeMobile from './Issues/DispatchAndPickUp/GoldSilverDispatchCharge/GoldSilverDispatchChargeMobile';

import BadStateProduct from './Issues/Products/BadState';
import Incomplete from './Issues/Products/Incomplete';
import OtherProduct from './Issues/Products/OtherProduct';
import NotWorking from './Issues/Products/NotWorking';
import WithAlarm from './Issues/Products/WithAlarm';

import CancelPurchase from './Issues/CancelPurchase/CancelPurchase';
import StatusCancelPurchase from './Issues/CancelPurchase/StatusCancelPurchase';
import ReverseOutOfTime from './Issues/CancelPurchase/ReverseOutOfTime';

import AssembleProduct from './Issues/AssembleProduct/AssembleProduct';

import ChangePassRipleyCom from './Issues/PurchasesRipleyCom/ChangePass';
import ChangePassMobile from './Issues/PurchasesRipleyCom/ChangePass/ChangePassMobile';
import ChangeEmail from './Issues/PurchasesRipleyCom/ChangeEmail';
import ChangeEmailMobile from './Issues/PurchasesRipleyCom/ChangeEmail/ChangeEmailMobile';
import InvoiceCopy from './Issues/PurchasesRipleyCom/InvoiceCopy';
import ProblemInPurchase from './Issues/PurchasesRipleyCom/ProblemInPurchase';
import PageError from './Issues/PurchasesRipleyCom/PageError';
import RemoveClientData from './Issues/PurchasesRipleyCom/RemoveClientData';

import GiftCardBalance from './Issues/GiftCards/GiftCardBalance';
import ExtendValidity from './Issues/GiftCards/ExtendValidity';
import ProblemsGiftCard from './Issues/GiftCards/ProblemsGiftcard';
import ProblemsGiftcardMobile from './Issues/GiftCards/ProblemsGiftcard/ProblemsGiftcardMobile';

import ArcoLawExercises from './Issues/ArcoLaw/ArcoLawExercises';

import Rphone from '../innerForms/Rphone';
import Debit from '../innerForms/Debit';
import Providers from '../innerForms/Providers';
import Store from '../innerForms/Store';

import PrivateRoute from './Middlewares/privateRoute';

const Routes = ({ ...props }) => {
  const { mobile } = props;
  const { authorized } = useSelector((state) => state.routesAuthSlice);

  return (
    <Switch>
      <Route exact path={HOME_ROUTE}>
        <Contact mobile={mobile} />
      </Route>
      <Route path={SELECT_PRODUCT_MOBILE}>
        <SelectProductMobile mobile={mobile} />
      </Route>
      <Route path={MOTIVE_MESSAGE_MOBILE}>
        <AlertMessageMobile mobile={mobile} />
      </Route>

      <Route path={TICKET_SUCCESSFUL}>
        <TicketConfirmation mobile={mobile} />
      </Route>
      <Route path={TICKET_SUCCESSFUL_INNER_FORMS}>
        <TicketConfirmationInnerForms mobile={mobile} />
      </Route>
      <Route path={TICKET_ERROR}>
        <TickerError />
      </Route>

      <PrivateRoute
        path={NOT_RECEIVED_PRODUCT}
        authorized={authorized}
        component={() => {
          return (
            <NotReceived issueForm mobile={mobile} motiveId="2" typeId="1" />
          );
        }}
      />
      <Route path={NOT_RECEIVED_PRODUCT_MOBILE}>
        <NotReceivedMobile mobile={mobile} />
      </Route>
      <PrivateRoute
        path={AUTHORIZE_THIRD}
        authorized={authorized}
        component={() => {
          return (
            <AuthorizeThird
              issueForm
              mobile={mobile}
              motiveId="28"
              typeId="1"
            />
          );
        }}
      />
      <Route path={AUTHORIZE_THIRD_MOBILE}>
        <AuthorizeThirdMobile mobile={mobile} />
      </Route>
      <PrivateRoute
        path={CHANGE_ADDRESS}
        authorized={authorized}
        component={() => {
          return (
            <ChangeAddress issueForm mobile={mobile} motiveId="10" typeId="1" />
          );
        }}
      />
      <Route path={CHANGE_ADDRESS_MOBILE}>
        <ChangeAddressMobile mobile={mobile} />
      </Route>
      <PrivateRoute
        path={CHANGE_DATE}
        authorized={authorized}
        component={() => {
          return (
            <ChangeDate issueForm mobile={mobile} motiveId="1" typeId="1" />
          );
        }}
      />
      <Route path={CHANGE_DATE_MOBILE}>
        <ChangeDateMobile mobile={mobile} />
      </Route>
      <PrivateRoute
        path={GOLD_DISPATCH_CHARGE}
        authorized={authorized}
        component={() => {
          return (
            <GoldSilverDispatchCharge
              issueForm
              mobile={mobile}
              motiveId="29"
              typeId="1"
            />
          );
        }}
      />
      <Route path={GOLD_DISPATCH_CHARGE_MOBILE}>
        <GoldSilverDispatchChargeMobile mobile={mobile} />
      </Route>

      <PrivateRoute
        path={BAD_STATE_PRODUCT}
        authorized={authorized}
        component={() => {
          return (
            <BadStateProduct
              issueForm
              mobile={mobile}
              motiveId="6"
              typeId="2"
            />
          );
        }}
      />
      <PrivateRoute
        path={INCOMPLETE_PRODUCT}
        authorized={authorized}
        component={() => {
          return (
            <Incomplete issueForm mobile={mobile} motiveId="4" typeId="2" />
          );
        }}
      />
      <PrivateRoute
        path={OTHER_PRODUCT}
        authorized={authorized}
        component={() => {
          return (
            <OtherProduct issueForm mobile={mobile} motiveId="3" typeId="2" />
          );
        }}
      />
      <PrivateRoute
        path={NOT_WORKING_PRODUCT}
        authorized={authorized}
        component={() => {
          return (
            <NotWorking issueForm mobile={mobile} motiveId="5" typeId="2" />
          );
        }}
      />
      <PrivateRoute
        path={PRODUCT_WITH_ALARM}
        authorized={authorized}
        component={() => {
          return (
            <WithAlarm issueForm mobile={mobile} motiveId="37" typeId="2" />
          );
        }}
      />

      <PrivateRoute
        path={CANCEL_PURCHASE}
        authorized={authorized}
        component={() => {
          return (
            <CancelPurchase issueForm mobile={mobile} motiveId="7" typeId="3" />
          );
        }}
      />
      <PrivateRoute
        path={STATUS_CANCEL_PURCHASE}
        authorized={authorized}
        component={() => {
          return (
            <StatusCancelPurchase
              issueForm
              mobile={mobile}
              motiveId="11"
              typeId="3"
            />
          );
        }}
      />

      <PrivateRoute
        path={REVERSE_OUT_OF_TIME}
        authorized={authorized}
        component={() => {
          return (
            <ReverseOutOfTime
              issueForm
              mobile={mobile}
              motiveId="44"
              typeId="3"
            />
          );
        }}
      />

      <PrivateRoute
        path={ASSEMBLE_PRODUCT}
        authorized={authorized}
        component={() => {
          return (
            <AssembleProduct
              issueForm
              mobile={mobile}
              motiveId="9"
              typeId="5"
            />
          );
        }}
      />

      <PrivateRoute
        path={CHANGE_PASS_RIPLEY_COM}
        authorized={authorized}
        component={() => {
          return (
            <ChangePassRipleyCom
              issueForm
              mobile={mobile}
              motiveId="27"
              typeId="7"
            />
          );
        }}
      />
      <Route path={CHANGE_PASS_RIPLEY_COM_MOBILE}>
        <ChangePassMobile mobile={mobile} />
      </Route>
      <PrivateRoute
        path={CHANGE_EMAIL}
        authorized={authorized}
        component={() => {
          return (
            <ChangeEmail issueForm mobile={mobile} motiveId="26" typeId="7" />
          );
        }}
      />
      <Route path={CHANGE_EMAIL_MOBILE}>
        <ChangeEmailMobile mobile={mobile} />
      </Route>

      <PrivateRoute
        path={INVOICE_COPY}
        authorized={authorized}
        component={() => {
          return (
            <InvoiceCopy issueForm mobile={mobile} motiveId="18" typeId="7" />
          );
        }}
      />
      <PrivateRoute
        path={PROBLEM_IN_PURCHASE}
        authorized={authorized}
        component={() => {
          return (
            <ProblemInPurchase
              issueForm
              mobile={mobile}
              motiveId="17"
              typeId="7"
            />
          );
        }}
      />
      <PrivateRoute
        path={PAGE_ERROR}
        authorized={authorized}
        component={() => {
          return <PageError mobile={mobile} motiveId="33" typeId="7" />;
        }}
      />
      <PrivateRoute
        path={REMOVE_CLIENT_DATA}
        authorized={authorized}
        component={() => {
          return (
            <RemoveClientData
              mobile={mobile}
              issueForm
              motiveId="43"
              typeId="7"
            />
          );
        }}
      />

      <Route path={GET_GIFTCARD_BALANCE}>
        <GiftCardBalance mobile={mobile} motiveId="22" typeId="9" />
      </Route>
      <PrivateRoute
        path={EXTEND_VALIDITY}
        authorized={authorized}
        component={() => {
          return <ExtendValidity mobile={mobile} motiveId="31" typeId="9" />;
        }}
      />
      <PrivateRoute
        path={PROBLEMS_GIFTCARD}
        authorized={authorized}
        component={() => {
          return (
            <ProblemsGiftCard
              issueForm
              mobile={mobile}
              motiveId="36"
              typeId="9"
            />
          );
        }}
      />
      <Route path={PROBLEMS_GIFTCARD_MOBILE}>
        <ProblemsGiftcardMobile mobile={mobile} />
      </Route>

      <Route path={ARCO_LAW_INFO}>
        <ArcoLawExercises issueForm mobile={mobile} motiveId="45" typeId="12" />
      </Route>

      <Route path={RPHONE}>
        <Rphone issueForm mobile={mobile} />
      </Route>
      <Route path={DEBIT}>
        <Debit issueForm mobile={mobile} />
      </Route>
      <Route path={PROVIDERS}>
        <Providers issueForm mobile={mobile} />
      </Route>
      <Route path={STORE}>
        <Store issueForm mobile={mobile} />
      </Route>

      <Route path="*">
        <Redirect to={HOME_ROUTE} />
      </Route>
    </Switch>
  );
};

Routes.propTypes = {
  mobile: PropTypes.bool,
};

export default Routes;
